import React from 'react';
import { Phone, MessageCircle, MapPin, Clock } from 'lucide-react';
interface TopBarProps {
  language: 'en' | 'es';
}
export function TopBar({
  language
}: TopBarProps) {
  const t = {
    en: {
      serving: 'Serving Odessa, Midland & All West Texas'
    },
    es: {
      serving: 'Sirviendo Odessa, Midland y todo West Texas'
    }
  };
  const text = t[language];
  return <div className="w-full overflow-hidden bg-gradient-to-r from-gold via-yellow-600 to-gold text-black py-2.5 px-4 font-inter" data-id="element-385">
      <div className="max-w-7xl mx-auto flex items-center justify-center flex-wrap gap-x-4 gap-y-1 text-xs sm:text-sm font-semibold tracking-wide" data-id="element-386">
        <span className="hidden md:flex items-center gap-1.5" data-id="element-387">
          <MapPin size={14} strokeWidth={2.5} data-id="element-388" />
          {text.serving}
        </span>
        <span className="hidden sm:inline text-black/30" data-id="element-389">|</span>
        <span className="flex items-center gap-1.5" data-id="element-390">
          <Phone size={14} strokeWidth={2.5} data-id="element-391" />
          <a href="tel:+14325287892" className="hover:text-black/70 transition-colors" data-id="element-392">
            432-528-7892
          </a>
          <a href="sms:+14325287892" className="hidden sm:inline hover:text-black/70 transition-colors" data-id="element-393">
            <MessageCircle size={12} strokeWidth={2.5} data-id="element-394" />
          </a>
        </span>
        <span className="text-black/30" data-id="element-395">|</span>
        <span className="flex items-center gap-1.5" data-id="element-396">
          <Phone size={14} strokeWidth={2.5} data-id="element-397" />
          <a href="tel:+14328034737" className="hover:text-black/70 transition-colors" data-id="element-398">
            432-803-4737
          </a>
          <a href="sms:+14328034737" className="hidden sm:inline hover:text-black/70 transition-colors" data-id="element-399">
            <MessageCircle size={12} strokeWidth={2.5} data-id="element-400" />
          </a>
        </span>
        <span className="hidden sm:inline text-black/30" data-id="element-401">|</span>
        <span className="flex items-center gap-1.5" data-id="element-402">
          <Clock size={14} strokeWidth={2.5} data-id="element-403" />
          24/7
        </span>
      </div>
    </div>;
}